// eslint-disable-next-line no-restricted-globals
export const transportDocumentsEndpoint = `${location.host}/api/v2/transport-documents`;
